import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const WarningBox = styled(Box)(({ theme }) => ({
	backgroundColor: '#FFE6E5',
	padding: '12px 20px',
	borderRadius: 7,
	marginBottom: theme.spacing(2),
	display: 'flex',
	alignItems: 'center',
	fontWeight: 500,
	fontSize: 14,
	borderLeftWidth: 5,
	borderLeftStyle: 'solid',
	color: '#DC3545',
	borderLeftColor: '#DC3545',
}));

export interface ErrorNode {
	kind: 'error';
	message?: string;
	title?: string;
}

interface ErrorChatProps {
	node: ErrorNode;
}

const ErrorChat: React.FC<ErrorChatProps> = ({ node }) => {
	return (
		<Card
			variant="outlined"
			sx={{ p: 3, maxWidth: 500, borderRadius: 2, mb: 2 }}
		>
			<WarningBox>
				❌ <Box width={12} />
				{node?.title}
			</WarningBox>

			<Typography
				variant="subtitle2"
				color={'#45556C'}
				fontWeight={400}
				sx={{ fontSize: 13 }}
			>
				{node?.message}
			</Typography>
		</Card>
	);
};

export default ErrorChat;
